module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0061.jpg?v=e808f26b";